/* eslint-disable react/no-this-in-sfc */
import React, { useEffect, useState } from 'react';
import _keys from 'lodash/keys';
import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import highchartsMore from 'highcharts/highcharts-more';
import highchartsAccessibility from 'highcharts/modules/accessibility';
import { shallowEqual, useSelector } from 'react-redux';
import { makeDefaultNwcChartOptions } from '../../../../../common/charts/highchart-utilities';
import { lineGlobalColors } from '../../../../../common/charts/types/highchartsColorTheme';
import { getChartTimePeriodsAdjustedWorkingCapitalForNwc } from '../../../../../common/engine/selectors/adjustmentSelectors';
import {
  financialValue,
  getFinancialScale,
} from '../../../../../common/services/textService';
import { getProjectFinancials } from '../../../../project/projectSlice';
import './NetWorkingCapitalChart.scss';

const NetWorkingCapitalChart = () => {
  highchartsAccessibility(Highcharts);
  highchartsMore(Highcharts);
  Highcharts.setOptions({
    colors: lineGlobalColors,
  });

  const [chartOptions, setChartOptions] = useState(
    makeDefaultNwcChartOptions(0)
  );

  const financialsDisplaySettings = useSelector(
    getProjectFinancials,
    shallowEqual
  );
  const chartPeriodsAdjustedWorkingCapital = useSelector(
    getChartTimePeriodsAdjustedWorkingCapitalForNwc
  );

  useEffect(() => {
    const seriesData = _keys(chartPeriodsAdjustedWorkingCapital).map(
      (period) => ({
        y: chartPeriodsAdjustedWorkingCapital[period],
        accessibility: { description: period },
      })
    );

    setChartOptions({
      subtitle: {
        text: getFinancialScale(financialsDisplaySettings),
      },
      xAxis: {
        categories: _keys(chartPeriodsAdjustedWorkingCapital),
      },
      series: [
        {
          name: 'Adjusted Working Capital',
          color: Highcharts.getOptions().colors[3],
          data: seriesData,
        },
      ],
      legend: {
        enabled: false,
      },
      tooltip: {
        enabled: true,
        useHTML: true,
        style: {
          fontFamily: 'Helvetica',
          lineHeight: '1.4rem',
        },
        formatter() {
          const timePeriod = this.x;
          const nwcValue = financialValue(this.y, {
            decimalCount: financialsDisplaySettings.financialsDecimalCount,
          });

          return `${timePeriod}<br/><b>${nwcValue}</b>`;
        },
      },
    });
  }, [financialsDisplaySettings, chartPeriodsAdjustedWorkingCapital]);

  return (
    <div
      data-testid="networking-capital-chart"
      className="nwc-chart-container"
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      tabIndex="0"
    >
      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
    </div>
  );
};

export default NetWorkingCapitalChart;
